import { mapMutations, mapState } from 'vuex';

import GMapsApiLoader from 'google-maps-api-loader';

import constants from '@/constants';

import forEach from 'lodash/forEach';
import find from 'lodash/find';
import { flatMap } from 'lodash/collection';

import { GMAPS_API_KEY } from '../../../config/maps-api';

export default {
  computed: {
    ...mapState(['geofence', 'googleMapsApi', 'employee']),
  },

  methods: {
    ...mapMutations(['setGoogleMapsApi']),

    getTimeEntryGeofenceResult(timeEntry, assignmentId) {
      let finalResult = null;
      if (assignmentId) {
        const assignmentGeofences = find(this.geofence, (fence) => fence.assignmentId === assignmentId).geofences;

        if (assignmentGeofences.length === 0) return constants.LocationData.GeofenceResult.OUTSIDE;

        const position = {
          lat: Number(timeEntry.latitude),
          lng: Number(timeEntry.longitude),
          acc: Number(timeEntry.accuracy),
        };

        const results = [];
        forEach(assignmentGeofences, (geofence) => {
          results.push({
            id: geofence.id,
            result: this.getCircularFenceResult(position, geofence, geofence.radius),
          });
        });
        finalResult = find(results, (result) => result.result !== constants.LocationData.GeofenceResult.OUTSIDE);
      }

      return finalResult || { name: null, result: constants.LocationData.GeofenceResult.OUTSIDE };
    },

    getLocationGeofenceResult(position) {
      const empAssignmentIds = flatMap(this.employee.assignments, (assignment) => assignment.id);

      let geofences = [];
      forEach(empAssignmentIds, (id) => {
        const assignmentGeofence = this.geofence.find((fence) => fence.assignmentId === id);

        if (assignmentGeofence && assignmentGeofence.geofences) {
          geofences = geofences.concat(assignmentGeofence.geofences);
        }
      });

      if (geofences.length === 0) return constants.LocationData.GeofenceResult.OUTSIDE;

      const results = [];

      forEach(geofences, (geofence) => {
        results.push({
          name: geofence.name,
          result: this.getCircularFenceResult(position, geofence, geofence.radius),
        });
      });

      const finalResult = find(results, (result) => result.result !== constants.LocationData.GeofenceResult.OUTSIDE);

      return finalResult || { name: null, result: constants.LocationData.GeofenceResult.OUTSIDE };
    },

    getCircularFenceResult(position, center, radius) {
      const inspectedLatLong = new this.googleMapsApi.maps.LatLng(position);
      const geofenceCircle = new this.googleMapsApi.maps.Circle({ center, radius });

      const distanceFromCenter = this.googleMapsApi.maps.geometry.spherical.computeDistanceBetween(
        geofenceCircle.center, inspectedLatLong,
      );

      if (geofenceCircle.getBounds().contains(inspectedLatLong)) {
        if ((distanceFromCenter + position.acc) < geofenceCircle.radius) {
          return constants.LocationData.GeofenceResult.INSIDE;
        }
        return constants.LocationData.GeofenceResult.BORDERING_INSIDE;
      }

      if (distanceFromCenter < (geofenceCircle.radius + position.acc)) {
        return constants.LocationData.GeofenceResult.BORDERING_OUTSIDE;
      }
      return constants.LocationData.GeofenceResult.OUTSIDE;
    },
  },

  mounted() {
    if (!this.googleMapsApi) {
      this.setGoogleMapsApi(true);
      GMapsApiLoader({
        libraries: ['geometry'],
        apiKey: GMAPS_API_KEY,
      })
      .then((googleApi) => {
        this.setGoogleMapsApi(googleApi);
      })
      .catch(() => this.setGoogleMapsApi(null));
    }
  },
};
